import { Box, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Header from '../../components/Header';
import { useTranslation } from '../../hooks/useTranslation';
import { DataContext } from '../../contexts/DataContext';
import PrimaryButton from '../../components/PrimaryButton';
import FloatingActions from '../../components/FloatingActions';
import { UploadPicture } from '../../components/UploadPicture';
import { InputCode } from '../../components/InputCode';
import { HowGetCodeSheet } from '../../components/HowGetCodeSheet';
import LuxService from '../../services/LuxService';
import { ErrorPopUp } from '../../components/ErrorPopUp';
import i18n from '../../config/i18n';
import { PrimaryInput } from '../../components/PrimaryInput';
import { HowGetCodeSheetManual } from '../../components/HowGetCodeSheetManual';

function ManualDeviceCodePage(props) {
  const { showDeviceCodePage, setShowDeviceCodePage } = props;
  const { t } = useTranslation();
  const { steps, currentStep, data, setData, setCurrentStep, trackEvent,flowNumber } =
    useContext(DataContext);
  const [showHowOpen, setShowHowOpen] = useState(false);
  const [codeError, setCodeError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    trackEvent({ nav_to_old_device: 1 });
  }, [trackEvent]);

  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const onSubmit = async () => {
    try {
      setIsLoading(true);

   
        const res=await LuxService.createUser({
          ...data,
          deviceUuid: undefined,
          language: i18n.language,
          code:data?.manualDeviceCode,
          manualDeviceCode: data?.manualDeviceCode,
          flowNumber,
          ...(data?.user_uuid ? { user_uuid: data?.user_uuid } : {}),
        });
      
      setData({
        ...data,
        submitted: true,
  coupon:       flowNumber === 1 &&
      !data?.isReturning &&
      data?.storeHasCouponlogic && data?.country?.includes('lux')?   (res?.discount_code?.length ? res?.discount_code : data?.coupon) : data?.coupon,
        devices: [
          ...(data?.devices ? data?.devices : []),
          {
            src: data?.file?.src,
            code: data?.manualDeviceCode,
            name: data?.manualDeviceCode,
          },
        ],
      });

      setCurrentStep(currentStep + 1);
      trackEvent({ device_added: 1 });
    } catch (err) {
      if (err?.code === '1001') {
        trackEvent({ error_device_already_registered: 1 });
      } else if (err?.code === '1000') {
        trackEvent({ error_code_not_read: 1 });
      }
      if(err?.code+ '' === '1003') {
setData({
            ...data,
            errors: {
              ...data?.errors,
              email: err?.code,
            },
          })
          setCurrentStep(7);
          return 
        }
      setData({
        ...data,
        errors: {
          ...data?.errors,
          manualDeviceCode:  err?.code,
        },
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && data?.manualDeviceCode?.length > 0) {
      onSubmit();
    }
  };

  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
        pointerEvents: isLoading ? 'none' : 'all',
        overflowY: 'auto',
        position: 'relative',
      }}
    >
      <Header steps={steps} currentStep={currentStep} />
      <HowGetCodeSheetManual open={showHowOpen} setOpen={(b) => setShowHowOpen(b)} />
      <ErrorPopUp
        errorText={t('errors.' + data?.errors?.manualDeviceCode)}
        error={data?.errors?.manualDeviceCode || data?.errors?.code || codeError}
        setError={(v) => {
          setCodeError(false);
          setData({
            ...data,
            byPicture: false,
            byCode: false,
            manualDeviceCode: undefined,
            code: '',
            errors: {
              ...data?.errors,
              code: false,
              file: false,
              manualDeviceCode: false,
            },
          });
        }}
      />
      <div
        style={{
          marginTop: '20px',
          display: 'flex',
          flexDirection: 'column',
          paddingInline: '24px',
          alignItems: 'stretch',
          textAlign: 'left',
          height: 'calc(100% + 40px)',
        }}
      >
        <Typography
          sx={{
            fontSize: '32px',
            fontWeight: '700',
            lineHeight: '38.46px',
            color: '#44546A',
          }}
        >
          {t('manualDeviceCode.title')}
        </Typography>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: '500',
            marginTop: '11px',
            color: '#44546A',
          }}
        >
          {t('manualDeviceCode.description')}
        </Typography>
        <Box sx={{ marginTop: '24px', width: '100%' }}>
          <PrimaryInput
            value={data?.manualDeviceCode}
            inputRef={inputRef}
            autoFocus
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              if (e.key === 'Enter' && data?.manualDeviceCode?.length > 0) {
                onSubmit();
                return;
              }
              setData({
                ...data,
                manualDeviceCode: e?.target?.value,
                errors: { ...data?.errors, manualDeviceCode: false },
              });
            }}
            sx={{ width: '100%' }}
          />
        </Box>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: '700',
            marginTop: '24px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() => setShowHowOpen(true)}
        >
          {t('manualDeviceCode.wheretofind')}
        </Typography>

        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: '700',
            marginTop: '20px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() => setShowDeviceCodePage(false)}
        >
          {t('manualDeviceCode.enteritmanually')}
        </Typography>
      </div>
      <FloatingActions childrenStyle={{}}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            paddingInline: '24px',
            alignItems: 'stretch',
            gap: '20px',
          }}
        >
          {' '}
          {Boolean(codeError) && (
            <div
              style={{
                marginTop: '20px',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                gap: '16px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '8px',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                >
                  <path
                    d="M13.25 26.5C10.6294 26.5 8.06765 25.7229 5.8887 24.267C3.70975 22.811 2.01146 20.7417 1.0086 18.3206C0.00574094 15.8994 -0.256653 13.2353 0.254601 10.6651C0.765855 8.09481 2.02779 5.73388 3.88084 3.88084C5.73388 2.02779 8.09481 0.765855 10.6651 0.254601C13.2353 -0.256653 15.8994 0.00574094 18.3206 1.0086C20.7417 2.01146 22.811 3.70975 24.267 5.8887C25.7229 8.06765 26.5 10.6294 26.5 13.25C26.4971 16.7632 25.1001 20.1317 22.6159 22.6159C20.1317 25.1001 16.7632 26.4971 13.25 26.5ZM13.25 1.84884C10.9951 1.84884 8.79077 2.51751 6.91586 3.77028C5.04095 5.02306 3.57963 6.80368 2.7167 8.88697C1.85378 10.9703 1.628 13.2626 2.06791 15.4743C2.50783 17.6859 3.59368 19.7174 5.18816 21.3118C6.78265 22.9063 8.81414 23.9922 11.0257 24.4321C13.2374 24.872 15.5297 24.6462 17.613 23.7833C19.6963 22.9204 21.4769 21.4591 22.7297 19.5841C23.9825 17.7092 24.6512 15.5049 24.6512 13.25C24.6476 10.2273 23.4452 7.32948 21.3079 5.19213C19.1705 3.05477 16.2727 1.85243 13.25 1.84884Z"
                    fill="#FF2D2D"
                  />
                  <path
                    d="M16.9476 9.55225L9.55225 16.9476"
                    stroke="#FF2D2D"
                    stroke-width="1.84884"
                    stroke-linecap="round"
                  />
                  <path
                    d="M9.55241 9.55225L16.9478 16.9476"
                    stroke="#FF2D2D"
                    stroke-width="1.84884"
                    stroke-linecap="round"
                  />
                </svg>
                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: '700',
                    lineHeight: '19px',
                  }}
                >
                  {t('errors.' + data?.errors?.file)}
                </Typography>
              </div>
              <Typography
                sx={{
                  marginInline: 'auto',
                  pointer: 'cursor',
                  textDecoration: 'underline',
                  fontSize: '16px',
                  fontWeight: '700',
                  lineHeight: '19.7px',
                }}
                onClick={() => {
                  setCodeError(false);
                  setData({
                    ...data,
                    byPicture: false,
                    byCode: false,
                    file: undefined,
                    code: '',
                    errors: { ...data?.errors, code: false, file: false },
                  });
                }}
              >
                {t('tryagain')}
              </Typography>
            </div>
          )}
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '8px',
            }}
          >
            {data?.devices?.length > 0 && (
              <button
                onClick={() => {
                  setCurrentStep(currentStep + 1);
                }}
                style={{
                  outline: 'none',
                  border: 'none',
                  borderRadius: '50%',
                  width: '57px',
                  height: '57px',
                  padding: 0,
                  cursor: 'pointer',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="57"
                  height="57"
                  viewBox="0 0 57 57"
                  fill="none"
                >
                  <rect
                    opacity="0.1"
                    width="57"
                    height="57"
                    rx="28.5"
                    transform="matrix(-1 0 0 1 57 0)"
                    fill="#44546A"
                  />
                  <path
                    d="M35 29H22M22 29L27.2 24M22 29L27.2 34"
                    stroke="#44546A"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            )}
            <PrimaryButton
              style={{ flex: 1 }}
              isLoading={isLoading}
              onClick={() => {
                onSubmit();
              }}
              disabled={
                !data?.manualDeviceCode?.length ||
                data?.errors?.manualDeviceCode
              }
            >
              {t(
                !(data?.byPicture && !data?.code?.length && !data?.submitted)
                  ? 'continue'
                  : 'manualDeviceCode.adddevice'
              )}
            </PrimaryButton>
          </div>
        </div>
      </FloatingActions>
    </Box>
  );
}

export default ManualDeviceCodePage;
